"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _colors = require("HubStyleTokens/colors");

var _reactRedux = require("react-redux");

var _MerchandiseSelectors = require("pricing-pages-unified-ui/selectors/MerchandiseSelectors");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UICloseButton = _interopRequireDefault(require("UIComponents/button/UICloseButton"));

var _PricingSelectors = require("../../../selectors/PricingSelectors");

var _CurrencySelectors = require("../../../selectors/CurrencySelectors");

var _PriceDisplay = _interopRequireDefault(require("../../common/pricing/PriceDisplay"));

var _ChargeTypes = require("self-service-api/constants/ChargeTypes");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _MerchandiseIdBillingNameKeyMap = _interopRequireDefault(require("self-service-api/constants/MerchandiseIdBillingNameKeyMap"));

var ShoppingCartItemContainer = _styledComponents.default.div.withConfig({
  displayName: "ShoppingCartItem__ShoppingCartItemContainer",
  componentId: "sc-1kon1hs-0"
})(["background-color:", ";padding:16px 24px;margin-bottom:8px;position:relative;"], _colors.GYPSUM);

var PlanTitle = _styledComponents.default.div.withConfig({
  displayName: "ShoppingCartItem__PlanTitle",
  componentId: "sc-1kon1hs-1"
})(["font-weight:600;"]);

var CloseButton = (0, _styledComponents.default)(_UICloseButton.default).withConfig({
  displayName: "ShoppingCartItem__CloseButton",
  componentId: "sc-1kon1hs-2"
})(["position:absolute;top:10px;right:10px;"]);

function ShoppingCartItem(_ref) {
  var additionalUnitQuantity = _ref.additionalUnitQuantity,
      merchandiseId = _ref.merchandiseId,
      onRemove = _ref.onRemove,
      unit = _ref.unit;
  var currencyCode = (0, _reactRedux.useSelector)(_CurrencySelectors.activeCurrencySelector);
  var products = (0, _reactRedux.useSelector)(_MerchandiseSelectors.merchandiseSelector);
  var calculatePriceAndItemConfig = (0, _reactRedux.useSelector)(_PricingSelectors.getCalculatePriceAndItemConfigSelector);
  var priceObject = calculatePriceAndItemConfig({
    merchandiseId: merchandiseId,
    additionalUnitQuantity: additionalUnitQuantity
  });
  var recurring = products[merchandiseId].chargeType === _ChargeTypes.RECURRING;
  var price = recurring ? priceObject.monthly.calculatedPrice : priceObject.oneTimeFee.calculatedPrice;
  var billingNameKey = _MerchandiseIdBillingNameKeyMap.default[merchandiseId];
  return _react.default.createElement(ShoppingCartItemContainer, {
    "data-selenium-class": "shopping-cart-item-container"
  }, _react.default.createElement(PlanTitle, null, _react.default.createElement(_FormattedMessage.default, {
    "data-selenium-class": "shopping-cart-item-title",
    message: "pricing-pages.merchandise." + billingNameKey + ".title"
  })), _react.default.createElement("div", null, _react.default.createElement(_PriceDisplay.default, {
    price: price,
    currencyCode: currencyCode
  }), recurring && _react.default.createElement(_FormattedMessage.default, {
    message: "bundles.shoppingCart.perMonth",
    useGap: true
  }), unit && ' | ', unit), _react.default.createElement(CloseButton, {
    color: _colors.EERIE,
    onClick: onRemove,
    size: "medium",
    "data-selenium-class": "shopping-cart-item-remove"
  }, "x"));
}

ShoppingCartItem.propTypes = {
  merchandiseId: _propTypes.default.number.isRequired,
  additionalUnitQuantity: _propTypes.default.number,
  onRemove: _propTypes.default.func.isRequired,
  unit: _propTypes.default.object
};
var _default = ShoppingCartItem;
exports.default = _default;
module.exports = exports.default;